var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5170_47638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 7.49967V12.4997C18.3346 13.4163 17.5846 14.1663 16.668 14.1663H15.8346V12.4997H16.668V7.49967H3.33464V12.4997H8.33464V14.1663H3.33464C2.41797 14.1663 1.66797 13.4163 1.66797 12.4997V7.49967C1.66797 6.58301 2.41797 5.83301 3.33464 5.83301H16.668C17.5846 5.83301 18.3346 6.58301 18.3346 7.49967ZM12.0846 15.833L12.993 13.8247L15.0013 12.9163L12.993 12.008L12.0846 9.99967L11.1763 12.008L9.16797 12.9163L11.1763 13.8247L12.0846 15.833ZM14.168 11.6663L14.6846 10.5163L15.8346 9.99967L14.6846 9.48301L14.168 8.33301L13.6513 9.48301L12.5013 9.99967L13.6513 10.5163L14.168 11.6663ZM12.0846 15.833L12.993 13.8247L15.0013 12.9163L12.993 12.008L12.0846 9.99967L11.1763 12.008L9.16797 12.9163L11.1763 13.8247L12.0846 15.833ZM14.168 11.6663L14.6846 10.5163L15.8346 9.99967L14.6846 9.48301L14.168 8.33301L13.6513 9.48301L12.5013 9.99967L13.6513 10.5163L14.168 11.6663Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5170_47638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButton);
export default __webpack_public_path__ + "static/media/actionButton.fe8ef1cdb8b79ebfb8c6d568590a6c2c.svg";
export { ForwardRef as ReactComponent };